import { render } from "./MerchantProfileForm.vue?vue&type=template&id=481b9556"
import script from "./MerchantProfileForm.vue?vue&type=script&lang=js"
export * from "./MerchantProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__